<template>
	<div class="permissionmanagement">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys"></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">权限组管理</div>
					<div class="contentcard">
						<div style="font-size: 14px; font-weight: 700;">新增权限组</div>
						<a-divider dashed style="margin: 10px 0;" />
						<div>
							<div style="width: 400px;display: inline-block;">
								<span style="font-size: 14px; font-weight: 700;display: inline-block;margin-right: 10px;">权限组名称</span>
								<a-input placeholder="请输入权限组名称" style="width: 260px" v-model="newpermissionname" />
							</div>
							<a-button type="primary" size="small" style="width: 96px;font-size: 12px;" @click="newpermission">保存</a-button>
						</div>
					</div>
					<div class="contentcard">
						<div style="font-size: 14px; font-weight: 700;margin-bottom: 10px;">权限组选择</div>
						<a-cascader :allowClear="false" :options="options" @change="onChange" placeholder="请选择权限组..." />

						<div style="font-size: 14px; font-weight: 700;margin:10px 0;">权限组功能选择</div>
						<a-tree checkable @check="onCheck" v-model="checkedKeys" :treeData="treeData" />
						<div style="text-align: center;margin-top: 10px;">
							<a-button type="primary" size="small" style="width: 96px;font-size: 12px;margin-right: 20px;" :disabled="!checkedKeys"
							 @click="savepermission">
								确定
							</a-button>
							<a-button type="primary" size="small" style="width: 96px;font-size: 12px;margin-right: 20px;" :disabled="!checkedKeys"
							 ghost @click="() => {this.groupChange(this.checkedKeys);}">
								取消
							</a-button>
						</div>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>
	</div>
</template>

<script>
	import CryptoJS from 'crypto-js';
	export default {
		data() {
			return {
				current: ['permissionmanagement'],
				openKeys: ['usermanagement'],
				treeData: [],
				newpermissionname: null,
				permission_list: [],
				permission_group: [],
				permissionsdef: [],
				platform: [],
				selectedKeys: [],
				permissions: [],
				checkedKeys: [],
				options: [],
				platform_bit: null,
				permission_id: null,
				permissionsdefdata: []
			};
		},
		created: function() {
			this.initialize();
		},
		methods: {
			onCheck(checkedKeys) {
				// console.log('onCheck', checkedKeys);
				let arr = [];
				for (let i = 0; i < checkedKeys.length; i++) {
					if (typeof checkedKeys[i] !== 'number') {
						arr.push(checkedKeys[i]);
					}
				}
				this.checkedKeys = arr;
				// console.log(arr);
			},
			onChange(value) {
				// console.log(value);
				var self = this;
				self.permission_id = value[0];
				self.platform_bit = value[1];
				self.checkedKeys = []
				self.treeData = [];
				for (let i = 0; i < self.permission_list.length; i++) {
					if (self.permission_list[i].platform_id == value[1] + 1) {
						let obj = {};
						obj.title = self.permission_list[i].aggregate_name;
						obj.key = self.permission_list[i].permission_bit;
						obj.children = [];
						for (let j = 0; j < self.permission_list[i].UIC_Admin_Permission_Lists.length; j++) {
							var obj2 = {};
							obj2.title = self.permission_list[i].UIC_Admin_Permission_Lists[j].permission_name;
							obj2.key = self.permission_list[i].permission_bit + '-' + self.permission_list[i].UIC_Admin_Permission_Lists[j].permission_value;
							obj.children.push(obj2);
						}
						self.treeData.push(obj);
					}
				}

				self.permission_group.forEach(function(value, index) {
					if (value.id == self.permission_id) {
						self.permissionsdefdata = JSON.parse(value.permission_values)[self.platform_bit];
					}
				});
				// console.log(self.permission_group);
				if (self.permissionsdefdata) {
					self.permissionsdefdata.forEach(function(value, index, arr) {
						if (value) {
							var tagstemp = self.reductionvalue(value);
							for (let i = 0; i < tagstemp.length; i++) {
								if (tagstemp[i] == '1') {
									var data = index + '-' + Math.pow(2, i);
									self.checkedKeys.push(data);
								}
							}
						}
					});
				}

			},
			reductionvalue(value) {
				value = (value.toString(2) + '').split('').reverse();
				return value;
			},
			initialize() {
				var self = this;
				this.$axios.get('/permission/permissionlist').then(function(res) {
					// console.log(res.data);
					// self.treeData = [];
					self.options = [];
					self.permission_list = res.data.permission_list;
					self.permission_group = res.data.permission_group;
					self.platform = res.data.plat_form;
					for (let j = 0; j < self.permission_group.length; j++) {
						let obj = {};
						obj.value = self.permission_group[j].id;
						obj.label = self.permission_group[j].permission_group_name;
						obj.children = [];
						for (let i = 0; i < self.platform.length; i++) {
							let obj2 = {};
							obj2.value = self.platform[i].platform_value;
							obj2.label = self.platform[i].platform_name;
							obj.children.push(obj2);
						}
						self.options.push(obj);
					}
				});
			},
			permissionsChange(checkedValue) {
				this.permissions = 0;
				for (let i = 0; i < checkedValue.length; i++) {
					this.permissions += checkedValue[i];
				}
				this.permissionsdef = checkedValue;
			},
			platChange(key) {
				// console.log(key);
				var self = this;
			},
			newpermission() {
				var self = this;
				if (!this.newpermissionname) {
					return this.$message.error('权限组名称不能为空');
				}
				this.$confirm({
					title: '提示',
					content: '是否新增权限组',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios
							.post('/permission/permissionlist/created', {
								params: {
									newpermissionname: self.newpermissionname
								}
							})
							.then(function(res) {
								self.initialize();
								self.checkedKeys = null;
								self.permissions = [];
								self.$notification.open({
									message: '通知',
									description: res.data,
									onClose: close
								});
							});
					},
					onCancel() {}
				});
			},
			savepermission() {
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否保存权限组修改',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios
							.post('/permission/permissionlist/save', {
								params: {
									platform_bit: self.platform_bit,
									permission_id: self.permission_id,
									select_group: self.checkedKeys
								}
							})
							.then(function(res) {
								self.initialize();
								self.$notification.open({
									message: '通知',
									description: res.data,
									onClose: close
								});
							});
					},
					onCancel() {}
				});
			}
		}
	};
</script>

<style>

	.permissionmanagement .contentcard {
		padding: 24px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// index.vue?7d8a8e20